import TYPES from '../../types';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import { CustomerOverviewStateManager } from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state-manager';
import CustomerOverviewState
  from '@/modules/home-dashboard/customer-overview/domain/state/customer-overview-state';

@Injectable()
export default class CustomerOverviewService {
  @Inject(TYPES.CUSTOMER_OVERVIEW_STATE_MANAGER)
  private readonly customer_overview_state_manager!: CustomerOverviewStateManager;

  get_customer_overview(): CustomerOverviewState {
    return this.customer_overview_state_manager.state;
  }
}
